import React from 'react';

import HandFiveIcon from './HandFiveIcon';
import HandFourIcon from './HandFourIcon';
import HandOneIcon from './HandOneIcon';
import HandThreeIcon from './HandThreeIcon';
import HandTwoIcon from './HandTwoIcon';

function HandIcon({ number, ...rest }) {
  if (number === 2) {
    return <HandTwoIcon {...rest} />;
  }
  if (number === 3) {
    return <HandThreeIcon {...rest} />;
  }
  if (number === 4) {
    return <HandFourIcon {...rest} />;
  }
  if (number === 5) {
    return <HandFiveIcon {...rest} />;
  }
  return <HandOneIcon {...rest} />;
}

export default HandIcon;
